import { Megaphone } from "lucide-react";

// Placeholder ad slot. Replace the inner content with your ad network code later.
export const AdSlot = ({ label = "Advertisement", height = "h-24", testid = "ad-slot" }) => {
  return (
    <div
      className={`w-full ${height} rounded-2xl border border-dashed border-white/15 bg-white/[0.03] grid place-items-center text-center overflow-hidden`}
      data-testid={testid}
    >
      {/* AD-NETWORK-CODE-HERE */}
      <div className="flex flex-col items-center gap-1 text-slate-600">
        <Megaphone size={18} />
        <span className="text-[11px] font-mono uppercase tracking-widest">{label}</span>
        <span className="text-[10px] text-slate-700">Ad space — your banner here</span>
      </div>
    </div>
  );
};
